import { render, staticRenderFns } from "./AttachQuestionnaire.vue?vue&type=template&id=6e52721c"
import script from "./AttachQuestionnaire.vue?vue&type=script&lang=js"
export * from "./AttachQuestionnaire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports